export const trans_6_1=[
  {
    id:1,
    english:' I visited my friends house yeasterday morning',
    vietnamese:'Tôi đã đi thăm nhà bạn tôi vào sáng ngày họ qua',
    user_message:''
  },
  {
    id:2,
    english:'He did not go to school last week',
    vietnamese:'Anh ấy không đến trường vào tuần trước',
    user_message:''
  },
  {
    id:3,
    english:'Did he miss the meeting yeasterday?',
    vietnamese:'Anh ấy bị lỡ cuộc họp hôm qua phải không?',
    user_message:''
  },
  {
    id:4,
    english:'We are going to see my mother tommorow',
    vietnamese:'Chúng ta sẽ đi gặp anh trai của tôi vào ngày mai',
    user_message:''
  }, 
  {
    id:5,
    english:'The sky is very black. It is going to rain',
    vietnamese:'Bầu trời đang tối dần. Có thể sẽ mưa',
    user_message:''
  }, 
]

export const trans_6_2=[
  {
    id:1,
    english:'We are going to have an internal meeting on Monday',
    vietnamese:'Thứ 2 chúng ta sẽ có một cuộc họp nội bộ',
    user_message:''
  },
  {
    id:2,
    english:'When will we meet?',
    vietnamese:'Chúng ta gặp nhau lúc mấy giờ?',
    user_message:''
  },
  {
    id:3,
    english:'What time is it now?',
    vietnamese:'Bây giờ là mấy giờ rồi?',
    user_message:''
  },
  {
    id:4,
    english:'What date is it today?',
    vietnamese:'Hôm nay là thứ mấy?',
    user_message:''
  },  
  {
    id:5,
    english:'How many months in a year?',
    vietnamese:'Một năm có bao nhiêu tháng?',
    user_message:''
  }
]